import { render, staticRenderFns } from "./AboutItemList.vue?vue&type=template&id=0b545346&scoped=true"
import script from "./AboutItemList.vue?vue&type=script&lang=js"
export * from "./AboutItemList.vue?vue&type=script&lang=js"
import style0 from "./AboutItemList.vue?vue&type=style&index=0&id=0b545346&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b545346",
  null
  
)

export default component.exports